import { Document, Page, pdfjs } from "react-pdf";
import { useState } from "react";

// IMPORTANT FIX
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

export default function PdfViewer({ file }) {
  const [numPages, setNumPages] = useState(null);

  return (
    <Document file={file} onLoadSuccess={({ numPages }) => setNumPages(numPages)}>
      {Array.from(new Array(numPages), (_, i) => (
        <Page key={i} pageNumber={i + 1} />
      ))}
    </Document>
  );
}